import { render, staticRenderFns } from "./CustomersModal.vue?vue&type=template&id=3f9dd6a3&scoped=true"
import script from "./CustomersModal.vue?vue&type=script&lang=js"
export * from "./CustomersModal.vue?vue&type=script&lang=js"
import style0 from "./CustomersModal.vue?vue&type=style&index=0&id=3f9dd6a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9dd6a3",
  null
  
)

export default component.exports